import * as React from 'react';
import * as ReactDOM from 'react-dom';
import l10n = require('diy/util/l10n');
import MwsColors = require('diy/material-ui/colors');

export interface NoticeProps {
}

export class Notice extends React.Component<NoticeProps, {}> {
    render() {
        const style = this.getStyle();
        return (
            <p className="privacy-policy-notice" style={style.root}
               dangerouslySetInnerHTML={{__html: l10n.getString('privacyPolicy.notice')}}>
            </p>
        );
    }

    private getStyle() {
        return {
            root: {
                margin: 0,
                padding: 0,
                fontSize: 'inherit',
                textAlign: 'inherit',
                color: MwsColors.mwsGrey900
            }
        };
    }
}

export function renderNotice(container: HTMLDivElement) {
    ReactDOM.render(<Notice />, container);
    return container;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/privacy/Notice.tsx
 **/